import React, { Component } from "react";

class ContentHeaderButtons extends Component {
  render() {
    return <div id="content-header-buttons">{this.props.children}</div>;
  }
}

export default ContentHeaderButtons;
